import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api';
const TOKEN_KEY = 'arcade_token';
const NICKNAME_KEY = 'arcade_nickname';

export const arcadeAuth = {
  getToken: (): string | null => localStorage.getItem(TOKEN_KEY),
  getNickname: (): string | null => localStorage.getItem(NICKNAME_KEY),
  isLoggedIn: (): boolean => Boolean(localStorage.getItem(TOKEN_KEY)),
  save: (token: string, nickname: string) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(NICKNAME_KEY, nickname);
  },
  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(NICKNAME_KEY);
  },
};

const client = axios.create({ baseURL: `${API_URL}/arcade` });

client.interceptors.request.use((config) => {
  const token = arcadeAuth.getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export interface ArcadeProfile {
  id: string;
  nickname: string;
  balance: number;
  createdAt: string;
  streak: { current: number; best: number };
  badges: { code: string; name: string; description: string; icon: string; awardedAt: string }[];
  history: { amount: number; reason: string; createdAt: string }[];
}

export interface RankingEntry {
  position: number;
  nickname: string;
  balance: number;
}

export const arcadeApi = {
  register: async (nickname: string): Promise<{ userId: string; token: string; nickname: string }> => {
    const response = await client.post('/register', { nickname });
    return response.data;
  },
  me: async (): Promise<ArcadeProfile> => (await client.get('/me')).data,
  ranking: async (): Promise<RankingEntry[]> => (await client.get('/ranking')).data,

  quizToday: async () => (await client.get('/quiz/today')).data,
  quizSubmit: async (answers: number[]) => (await client.post('/quiz/submit', { answers })).data,

  wordToday: async () => (await client.get('/word/today')).data,
  wordGuess: async (guess: string) => (await client.post('/word/guess', { guess })).data,

  candleToday: async () => (await client.get('/candle/today')).data,
  candleSubmit: async (answerIndex: number) => (await client.post('/candle/submit', { answerIndex })).data,
};

export const REASON_LABELS: Record<string, string> = {
  'quiz-diario': 'Quiz Diário',
  'crypto-word': 'Crypto Word',
  'candle-challenge': 'Candle Challenge',
  'streak-bonus': 'Bônus de sequência',
  'badge-bonus': 'Bônus de badge',
};
